//#region src/locales/ja/docs/versions.yaml
var data = {
	"download-buttons": {
		"latest-stable": "最新の安定版リリース",
		"latest-prerelease": "最新のプレリリース",
		"latest-nightly": "最新のナイトリービルド",
		"download": "ダウンロード",
		"view-release": "リリースを見る",
		"stable-use-case-1": "本番環境での利用",
		"stable-use-case-2": "安定した体験を求めるユーザー",
		"stable-use-case-3": "ライブ配信やコンテンツ制作",
		"prerelease-use-case-1": "新機能を早期に試したいユーザー",
		"prerelease-use-case-2": "テストや開発者へのフィードバック提供",
		"prerelease-use-case-3": "時折発生する不具合に対応できるユーザー"
	},
	"releases-list": {
		"stable": "安定版",
		"prerelease": "プレリリース",
		"nightly": "ナイトリー",
		"released-on": "リリース日",
		"built-on": "ビルド日",
		"no-releases": "現在利用可能なリリースはありません。直接{link}を確認してください。",
		"no-nightly": "現在利用可能なナイトリービルドはありません。直接{link}を確認してください。",
		"releases-page": "リリースページ",
		"workflow-page": "ワークフローページ"
	}
};
//#endregion
export { data as default };
